var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1489_25369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1489_25369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.975C11.8665 14.975 11.7415 14.9542 11.6248 14.9125C11.5081 14.8709 11.3998 14.8 11.2998 14.7L6.6998 10.1C6.51647 9.91672 6.4248 9.68338 6.4248 9.40005C6.4248 9.11672 6.51647 8.88338 6.6998 8.70005C6.88314 8.51672 7.11647 8.42505 7.3998 8.42505C7.68314 8.42505 7.91647 8.51672 8.0998 8.70005L11.9998 12.6L15.8998 8.70005C16.0831 8.51672 16.3165 8.42505 16.5998 8.42505C16.8831 8.42505 17.1165 8.51672 17.2998 8.70005C17.4831 8.88338 17.5748 9.11672 17.5748 9.40005C17.5748 9.68338 17.4831 9.91672 17.2998 10.1L12.6998 14.7C12.5998 14.8 12.4915 14.8709 12.3748 14.9125C12.2581 14.9542 12.1331 14.975 11.9998 14.975Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.c4c4b674291418fe255557d17b832786.svg";
export { ForwardRef as ReactComponent };